/*
 * @CopyRight    : 广州仰望星空云科技有限公司
 * @Author       : Kyle
 * @Email        : linyukai@xinyu668.com
 * @CreateTime   : 2023-09-19 11:12:00
 * @Description  : 全局组件注册
 */

/* 所有 import.meta.glob 的参数都必须以字面量传入。你不可以在其中使用变量或表达式。
匹配到的文件默认是懒加载的，通过动态导入实现，并会在构建时分离为独立的 chunk。如果你倾向于直接引入所有的模块（例如依赖于这些模块中的副作用首先被应用），你可以传入 { eager: true } 作为第二个参数： */
const modulesComponent = import.meta.glob([
  '@COMPONENTS/Pic.vue',
  '@COMPONENTS/AniBtn.vue',
  '@COMPONENTS/Empty.vue',
], { eager: true })
function changeStr(str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
const install = (app) => {
  Object.keys(modulesComponent).forEach(filename => {
    // 获取组件配置
    const component = modulesComponent[filename].default || modulesComponent[filename]
    const componentName = changeStr(component.name || /\/(\w+)\.vue/.exec(filename)[1])
    app.component(componentName, component)
  })
}
export default install
